module.exports = __webpack_public_path__ + "static/img/cac.e7c4a773.png";